
<template></template>
<script>
console.log("LOADED");

import CouponResponse from "@/components/CouponResponse.js";

import SpinnerButton from "@/components/SpinnerButton.vue";

export default {
  name: "Article",
  mixins: [CouponResponse],
  data() {
    return {
      user: this.$route.meta.user,
      ready: false,
      errorMessage: "",
      formValid: false
    };
  },
  mounted() {
    // DO we have a user ?
    console.log(this.$route.query)
    if (!this.user) {
      this.$router.push(
        {
          name: "register",
          query: { redirect: "article", url: this.$route.query.url }
        },
        () => {
          return;
        }
      );
    }
    if (!this.user.customer_id) {
      this.$userService.registerCustomer().then(subscription => {
        this.$userService.refreshLocalUser().then(() => {
          this.$router.push(
            {
              name: "creditcard",
              query: { redirect: "article", url: this.$route.query.url }
            },
            () => {
              return;
            }
          );
        });
      });
    } else {

      console.log('PHERD')
      this.$userService
        .getCustomer()
        .then(subscription => {
          // HANDLE ERROR
          const customer = subscription;
          // Do we have a credit card?

          //TODO: is the card invalid?
          console.log('customer')
          console.log(customer)
          let card = null;
          this.$userService
            .getPaymentMethod(customer.customer)
            .then((card) => {
              card = card;
              console.log('card')
              console.log(card);
              if (card) {

                window.location.href = this.$route.query.url;

              } else {

                this.$router.push(
                  {
                    name: "creditcard",
                    query: { redirect: "article", url: this.$route.query.url }
                  },
                  () => {
                    return;
                  }
                );


              }
            })
            .catch((err) => {

              console.log(err);
              this.$router.push(
                  {
                    name: "creditcard",
                    query: { redirect: "article", url: this.$route.query.url }
                  },
                  () => {
                    return;
                  }
                );
            });


        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>